// extracted by mini-css-extract-plugin
export default {"stars":"CardStars_stars__8xGlk"};